export const systemEventsExternalSteps = [
  {
    selector: "#system-events-date-range",
    content:
      "Filter events by start time using the Start Date and End Date fields to focus on a specific time period.",
  },
  {
    selector: "#system-events-status-filter",
    content:
      "Filter events by status: All, Open (default), or Closed.",
  },
  {
    selector: "#system-events-type-filter",
    content:
      "Narrow results by selecting specific event types, such as Channel Evaluation, Mirth Channel Threshold, or other threshold-related events.",
  },
  {
    selector: "#system-events-environment-filter",
    content:
      "Filter events by one or more environments within your assigned client.",
  },
  {
    selector: "#system-events-filter",
    content:
      "Apply filters to refine your results. Click Search to display matching events or Reset to clear all filters.",
  },
  {
    selector: "#system-events-data-grid",
    content:
      "View system events in this table. Click a row to see detailed information, add notes, or resolve the event.",
  },
];
